export default __webpack_public_path__ + "static/media/35.2f18cb29.png";